import React from 'react';
import { GRID_COLS, GRID_ROWS, CELL_SIZE, CELL_GAP, GRID_PADDING } from '../utils/constants';

function UnblockGrid({ children, prisonerRow = 2, isComplete = false }) {
  const gridWidth = GRID_COLS * CELL_SIZE + (GRID_COLS - 1) * CELL_GAP;
  const gridHeight = GRID_ROWS * CELL_SIZE + (GRID_ROWS - 1) * CELL_GAP;
  
  const cells = [];
  for (let y = 0; y < GRID_ROWS; y++) {
    for (let x = 0; x < GRID_COLS; x++) {
      cells.push(
        <div
          key={`cell-${x}-${y}`}
          className="unblock-grid__cell"
          style={{
            left: x * (CELL_SIZE + CELL_GAP),
            top: y * (CELL_SIZE + CELL_GAP),
            width: CELL_SIZE,
            height: CELL_SIZE,
          }}
        />
      );
    }
  }
  
  const exitTop = prisonerRow * (CELL_SIZE + CELL_GAP);
  const exitLineHeight = CELL_SIZE;
  
  return (
    <div
      className={`unblock-grid-wrapper ${isComplete ? 'unblock-grid-wrapper--open' : ''}`}
      style={{
        '--exit-row-top': `${exitTop + GRID_PADDING}px`,
        '--exit-row-height': `${exitLineHeight}px`,
      }}
    >
      <div
        className="unblock-grid"
        style={{
          width: gridWidth,
          height: gridHeight,
          padding: GRID_PADDING,
        }}
      >
        <div className="unblock-grid__inner">
          {cells}
          {children}
        </div>
        
        <div
          className={`unblock-grid__exit-slot ${isComplete ? 'unblock-grid__exit-slot--open' : ''}`}
          style={{
            top: exitTop + GRID_PADDING,
            height: exitLineHeight,
          }}
        />
        
        <div
          className={`unblock-grid__exit-line ${isComplete ? 'unblock-grid__exit-line--hidden' : ''}`}
          style={{
            top: exitTop + GRID_PADDING,
            height: exitLineHeight,
          }}
        />
        
        <div
          className={`unblock-grid__exit-glow ${isComplete ? 'unblock-grid__exit-glow--active' : ''}`}
          style={{
            top: exitTop + GRID_PADDING,
            height: exitLineHeight,
          }}
        />
      </div>
    </div>
  );
}

export default UnblockGrid;
